import { combineReducers } from "redux";
import userReducer from "@entities/user/model/user.reducer";
import usersReducer from "@entities/users/model/users.reducer";
import productsReducer from "@entities/products/model/products.reducer";
import productReducer from "@entities/product/model/product.reducer";
import projectsReducer from "@entities/projects/model/projects.reducer";
import projectReducer from "@entities/project/model/project.reducer";
import settingsReducer from "@entities/settings/model/settings.reducer";
import notificationsReducer from "@entities/notifications/model/notifications.reducer";

export default combineReducers({
  userData: userReducer,
  usersData: usersReducer,
  productsData: productsReducer,
  productData: productReducer,
  projectsData: projectsReducer,
  projectData: projectReducer,
  settingsData: settingsReducer,
  notificationsData: notificationsReducer,
});
